import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';

const styles = theme => ({
  margin: {
    margin: theme.spacing(2),
  },
});

class DialogErrosValidacao extends React.Component {
  render () {
    const { open, erros, handleClose, titulo } = this.props;

    return (
      <div>
        <Dialog open={open} onClose={handleClose} scroll='paper'>
          <DialogTitle>{titulo}</DialogTitle>
          <div>
            <List>
              {erros.map((erro, idx) =>
                <ListItem key={idx} style={{display: 'block'}}>
                  <ListItemText><Typography variant='button' color='secondary'>{'Registro - ' + erro.registro}</Typography></ListItemText>
                  <List>
                    {erro.mensagens.map((mensagem, indice) =>
                      <ListItem key={indice + 'erro'} divider>
                        <ListItemText primary={mensagem} />
                      </ListItem>)}
                  </List>
                </ListItem>)}
            </List>
          </div>
          <DialogActions>
            <Button onClick={handleClose} color='primary'>
              Fechar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(DialogErrosValidacao);
